import React from 'react';
import { PepwiseAuthControllerProvider } from './contexts/AuthContext';
import { CacheDataProvider } from './contexts/CacheDataContext';
import { TimezoneProvider } from './contexts/TimezoneContext';
import { FinOpsDrawerProvider } from './contexts/FinOpsDrawerContext';
import { FinOpsTabProvider } from './contexts/FinOpsTabContext';
import { SearchProvider } from './contexts/searchContext'

const PepwiseAppContextProviders = ({ children }: { children: React.ReactNode }) => {
	return (
		<PepwiseAuthControllerProvider>
			<SearchProvider>
				<FinOpsDrawerProvider>
					<FinOpsTabProvider>
						<CacheDataProvider>
							<TimezoneProvider>
								{children}
							</TimezoneProvider>
						</CacheDataProvider>
					</FinOpsTabProvider>
				</FinOpsDrawerProvider>
			</SearchProvider>
		</PepwiseAuthControllerProvider>
	);
};

export default PepwiseAppContextProviders;
